import { Routes } from "config/routes";

export const checkRoute = (path: string, routes: Routes): boolean => {
  return Object.values(routes.public).includes(path);
};
